import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';
import Versions from '../../components/versions';

@withText(props => ({
    active: <Text id='input.active-help'>Active</Text>,
    title: <Text id='input.title-help'>Title</Text>,
    ingress: <Text id='input.ingress-help'>Ingress</Text>,
    body: <Text id='input.body-help'>Body</Text>,
    tag: <Text id='input.tag-help'>Tag</Text>,
}))
@observer
class NewNews extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('news'),
        };
    }

    createNews = async () => {
        const { callback = () => {} } = this.props;
        const { newsStore } = this.props.stores;
        const { newNews } = newsStore;
        const response = await newsStore.adminCreate(newNews);
        if (response.status === 201) {
            callback();
        }
    }

    componentDidMount() {
        const { idx, id, isNew } = this.props;
        const { newsStore } = this.props.stores;
        if (!isNew) {
            // newsStore.adminSetFromIdx(idx);
            newsStore.adminSetFromId(id);
        }
    }

    render() {
        const { week, isNew, drawerLevel } = this.props;
        const { sections } = this.state;
        const { userStore, newsStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const { newNews, news } = newsStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>

                    <Versions stores={this.props.stores} type='news' id={news.id} key={`admin-news-${news.id}`} />

                    {/* <div class='w-100 d-flex flex-column justify-content-start'>
                        <xmp>{JSON.stringify(user.settings, null, 2)}</xmp>
                    </div> */}
                    {/* <xmp>{JSON.stringify(newNews, null, 4)}</xmp> */}
                    <h5 class='ms-3 mb-3'>
                        {isNew ? <Text id='news.new'>New news</Text> : <Text id='news.edit'>Edit news</Text>}
                    </h5>
                    <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                        <FormFieldsCompact
                            stores={this.props.stores}
                            sections={sections}
                            holdingStore={newsStore}
                            objectName={isNew ? 'newNews' : 'news'}
                            isNew={isNew}
                            drawerLevel={drawerLevel}
                            isAdmin={true}
                        />
                    </div>
                    {isNew && <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                        <button type='button' class='btn btn-primary rounded-pill' onClick={this.createNews}>
                            {isNew ? <Text id='news.create'>Create news</Text> : <Text id='news.save'>Save news</Text>}
                        </button>
                    </div>}
                </div>
            </div>
        </>);
    }
}

export default NewNews;
